
function isObject(obj){
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isString(obj){
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isFunction(obj){
  return Object.prototype.toString.call(obj) === '[object Function]';
}
// 判断版本号
// v1 > v2 ==> 1
// v1 < v2 ==> -1
// v1 == v2 ==> 0
function compareVersion(v1, v2)  {
    v1 = v1.split('.');
    v2 = v2.split('.');
    const len = Math.max(v1.length, v2.length);

    while (v1.length < len) {
      v1.push('0');
    }
    while (v2.length < len) {
      v2.push('0');
    }

    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i], 10);
      const num2 = parseInt(v2[i], 10);

      if (num1 > num2) {
        return 1;
      } else if (num1 < num2) {
        return -1;
      }
    }
    return 0;
}

  // 获取当前app的版本
function getApp(){
  let option ={};
  const { userAgent } = window.navigator; // DidaPinche/8.13.5
  let reg = /DidaPinche\/[\d\.]*/ig
  let result = userAgent.match(reg);
  option.version = result ? (result[0].replace('DidaPinche/','').trim()) : "";
  option.inApplication = userAgent.indexOf('DidaPinche') !== -1 // 在端上 
  if (userAgent.indexOf('[App]') > -1) {
    option.isDidaPinche = true;
  } else {
      option.isDidaTaxi = true;
  }
  return option
}

export default {
  isObject,
  isString,
  isFunction,
  compareVersion,
  appInfo : getApp()
}